import { motion } from 'motion/react';
import { ExternalLink, Star, Users, Calendar } from 'lucide-react';
import { ImageWithFallback } from './ImageWithFallback';

export function ExperiencesSection() {
  const experiences = [
    {
      id: '1',
      title: 'Chef\'s Table Tasting Menu',
      restaurant: 'L\'Artisan',
      image: 'https://images.unsplash.com/photo-1759349117105-467c7f8e1442?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBkaW5pbmclMjBleHBlcmllbmNlfGVufDF8fHx8MTc2NDAxNTYxNnww&ixlib=rb-4.1.0&q=80&w=1080',
      price: 295,
      duration: '3 hours',
      maxGuests: 8,
      rating: 4.9,
      description: 'An intimate 12-course tasting menu experience with wine pairings, led by Michelin-starred Chef Giovanni.',
      affiliateLink: '#',
      tags: ['Fine Dining', 'Wine Pairing', 'Exclusive'],
    },
    {
      id: '2',
      title: 'Pizza Making Masterclass',
      restaurant: 'Bella Napoli',
      image: 'https://images.unsplash.com/photo-1667207394004-acb6aaf4790e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMG1hcmdoZXJpdGElMjBjbG9zZSUyMHVwfGVufDF8fHx8MTc2NDA5ODA5NHww&ixlib=rb-4.1.0&q=80&w=1080',
      price: 125,
      duration: '2.5 hours',
      maxGuests: 12,
      rating: 4.8,
      description: 'Learn authentic Neapolitan pizza-making techniques from our master pizzaiolo, includes lunch and apron.',
      affiliateLink: '#',
      tags: ['Hands-On', 'Italian', 'Family Friendly'],
    },
  ];

  const handleBookNow = (experience) => {
    // In real app, this would track affiliate click and redirect
    console.log('Affiliate booking:', experience.id);
    window.open(experience.affiliateLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="py-16 border-t border-border">
      <div className="mb-12">
        <div className="w-1 h-12 bg-border mb-6"></div>
        <h2 className="serif text-5xl mb-4">Exclusive Dining Experiences</h2>
        <p className="text-sm text-muted-foreground max-w-2xl">
          Unique culinary adventures curated for food enthusiasts. Book directly and support local restaurants.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-8">
        {experiences.map((experience, index) => (
          <motion.article
            key={experience.id}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            className="border border-border group hover:border-foreground transition-colors"
          >
            {/* Image */}
            <div className="aspect-[16/10] overflow-hidden">
              <ImageWithFallback
                src={experience.image}
                alt={experience.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>

            {/* Content */}
            <div className="p-8">
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <p className="text-xs uppercase tracking-widest text-muted-foreground mb-2">
                    {experience.restaurant}
                  </p>
                  <h3 className="serif text-3xl mb-3">{experience.title}</h3>
                </div>
                <div className="flex items-center gap-1.5 bg-stone-100 px-3 py-1.5">
                  <Star className="w-3.5 h-3.5 fill-current" />
                  <span className="text-xs">{experience.rating}</span>
                </div>
              </div>

              <p className="text-sm text-muted-foreground leading-relaxed mb-6">
                {experience.description}
              </p>

              {/* Tags */}
              <div className="flex flex-wrap gap-2 mb-6">
                {experience.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 border border-border text-xs"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              {/* Meta Info */}
              <div className="flex items-center gap-6 mb-6 pb-6 border-b border-border text-xs text-muted-foreground">
                <div className="flex items-center gap-2">
                  <Calendar className="w-4 h-4" />
                  <span>{experience.duration}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Users className="w-4 h-4" />
                  <span>Max {experience.maxGuests} guests</span>
                </div>
              </div>

              {/* Price & CTA */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs text-muted-foreground mb-1">From</p>
                  <p className="serif text-3xl">${experience.price}</p>
                  <p className="text-xs text-muted-foreground">per person</p>
                </div>
                <button
                  onClick={() => handleBookNow(experience)}
                  className="px-6 h-12 bg-foreground text-background hover:bg-foreground/90 transition-colors text-xs uppercase tracking-widest flex items-center gap-2"
                >
                  <span>Book Now</span>
                  <ExternalLink className="w-4 h-4" />
                </button>
              </div>

              {/* Affiliate Disclosure */}
              <p className="text-xs text-muted-foreground mt-4 italic">
                RatedBite may earn a commission from bookings made through this link.
              </p>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  );
}

